import { apiAuth, apiResponseType } from ".";

export const getTenantsData = (page: number = 1): apiResponseType => apiAuth.get(`tenants?page=${page}`);

export const registerTenantData = (data) => 
    apiAuth.postForm("/tenants/store", data) as apiResponseType;
export const deleteTenantData = (tenid: string) =>
    apiAuth.delete(`tenants/${tenid}/destroy`) as apiResponseType;
export const updateTenantData = (tenid: string, data) =>
    apiAuth.postForm(`tenants/${tenid}/update`, data) as apiResponseType;

export const getShowTenant = (tenid: string) =>
    apiAuth.get(`tenants/${tenid}/show`) as apiResponseType;

export const searchTenantData = (params: {
    name: string
}): apiResponseType => apiAuth.get(`tenants?name=${params.name}`);

export const setStatusTenant = (tenid: string) =>
    apiAuth.put(`tenants/${tenid}/toggle-status`) as apiResponseType;

export const getSelectTenants = () =>
    apiAuth.get(`tenants/select`) as apiResponseType;